import styled from 'styled-components'
import Flex from 'components/Flex'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'
import {Input , Row, Collapse} from 'antd'


  export const OuterDiv = styled.div`
  width: 300px;
  height: 200px;
  overflow-y: scroll;
  scroll-behavior: smooth;
  padding:10px;
  background: white;
  box-shadow: 0px 4px 4px 0px #00000040;
  border-radius: 10px;
  ::-webkit-scrollbar {
    width: 5px;
  }

  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  ::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 5px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
  `

export const HeadingFlex = styled(Flex)`
width:100%;
height: 40px;
background:#DFDAF4;
border-radius: 5px;
justify-content: center;
align-items: center;
`
export const Footer = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid ${COLORS.GREY_T_85};
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  z-index: ${props => props.footerStyles && '1050'};`

  export const TitleText = styled.div`
  

font-family: Plus Jakarta Sans;
font-size: 12px;
font-weight: 400;
line-height: 11px;
color: #4B465C;
span{
    font-weight: 600 !important;
}
  `

  export const BoxFlex = styled(Flex)`
  gap: 15px;

`

export const SkilsBox = styled.div`
  width: ${props => !props?.width && '90px'};
  height: 40px;
  background: ${props => (!props?.isSelected ? '#f9fafe' : `${COLORS.WHITE}`)};
  border: ${props =>
    !props?.isSelected ? `1px solid ${COLORS.GREY_T_90}` : '1px solid #adb6ef'};
  border-radius: 10px;
  padding: 8px 12px;
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  text-align: center;
  color: ${COLORS.GREY_T_60};
  cursor: pointer;
  background: #f9fafe;
  color: ${props => props?.isSelected && '#3249d7'};
`
export const RowDiv = styled(Row)`
width: 100%;
padding: 15px;
border-bottom: 1px solid #D6D6D6;
`
export const SubTitleText = styled.div`
font-family: Plus Jakarta Sans;
font-size: 14px;
font-weight: 600;
line-height: 15px;
color: #4B465C;
padding-top: 8px;
overflow: wrap;

`

export const FilterCollapse = styled(Collapse)`
width:100%;
  background-color: #DBDADE !important;
  margin-right: 5px;


  .ant-collapse-header {
    position: relative;
    display: flex;
    flex-wrap: nowrap;
    align-items: flex-start;
    padding: 10px !important;
    font-weight: 600;
    border-radius: 15px !important;
    border-radius: 10px;
    color: #4B465C !important;
    line-height: 1.5715;
    cursor: pointer;
    transition: all 0.3s, visibility 0s;
  }
  .ant-collapse-content > .ant-collapse-content-box {
    padding: 0px !important;
}
.ant-collapse-borderless > .ant-collapse-item > .ant-collapse-content > .ant-collapse-content-box {
    padding: 0px !important;
}

  @media only screen and (max-device-width: 767px) {
    .ant-collapse-content > .ant-collapse-content-box {
      padding: 0px !important;
  }
  }
  @media only screen and (min-width: 768px )  and  (max-width : 1200px){
    .ant-collapse-content > .ant-collapse-content-box {
      padding: 0px !important;
  }
  }

 
`

export const FeedBackDiv = styled.div`
width:100%;
background: #F3F3F3;
padding:10px;
`

export const TitleText1 = styled.div`
  

font-family: Plus Jakarta Sans;
padding-top:7px;
font-size: 12px;
font-weight: 400;
line-height: 11px;
color: #4B465C;
span{
    font-weight: 600 !important;
}
  `

  export const FeedBackText = styled.div`
font-size: 12px;
font-weight: 500;
line-height: 18px;
color: #4B465C;
padding-top:8px;
  `

  export const FeedBackTextBox = styled(Input)`

  background: #F3F3F3;
  .ant-input {
    background-color: #F3F3F3;
  }
  `

  export const SubFLex = styled(Flex)`
  ${props => props.gap && `gap: ${props.gap};`}
  ${props => props.marginBottom && ` margin-bottom: ${props.marginBottom};`};
  ${props => props.paddingLeft && ` padding-left: ${props.paddingLeft};`};
  padding-top:10px;
`

export const StyledDivView = styled.div`

width: 300px;
height: 30px;
padding: 6px 5px 0px 5px;

border-radius: 5px;
background: #F2F3F5;
border: 0.5px solid #DBDADE;
font-family: Plus Jakarta Sans;
font-size: 12px;
font-weight: 600;
line-height: 15.12px;
color: #808697;
cursor: pointer;

span{
  float:right;
}
`